var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg003Products(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 540 540",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M375.8,441.7c-34.5,0-66.9-13.4-91.3-37.8-24.4-24.4-37.8-56.8-37.8-91.3s5.7-38.2,17.9-66.7c8.6-20.1,20.6-43.6,35.5-70,6-10.7,12.1-20.9,17.7-30.4-36-62.5-70.2-113.7-70.6-114.3l-12.5-18.7-12.5,18.7c-.4.6-39.4,59-77.9,127.1-52.6,93.1-79.2,159.6-79.2,197.6,0,93.5,76.1,169.6,169.6,169.6s116.9-33.8,146.4-84c-1.8,0-3.5.1-5.3.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M375.8,109.7s-99.1,148.1-99.1,202.8,44.4,99.1,99.1,99.1,99.1-44.4,99.1-99.1-99.1-202.8-99.1-202.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg003Products);
export default __webpack_public_path__ + "static/media/003-products.15b3dff126e35e2e18bc4caca9dcb361.svg";
export { ForwardRef as ReactComponent };